import * as React from 'react'
import { View, Text } from 'react-native'
import styled from '@theme/styled-components'

import MultiChoice from '@components/choice/MultiChoice'

import useI18n from '@i18n/useI18n'
import useReducer from '@store/useReducer'
import * as SiteStore from '@store/site/site'

import { FormikHelpers, useFormik } from 'formik'

interface Values {
  sites: string[]
}

const Site = ({ form, onForm }: AdminUserFormProps) => {
  const init: Values = React.useMemo(() => ({ sites: form.sites }), [form.sites])

  const i18n = useI18n()

  const sites = useReducer(SiteStore.store, (s) => s.sites)

  const onSubmit = (vals: Values, { setSubmitting }: FormikHelpers<Values>) => {
    onForm(vals).finally(() => setSubmitting(false))
  }

  const { values, setFieldValue, handleSubmit, dirty } = useFormik<Values>({
    enableReinitialize: true,
    initialValues: init,
    onSubmit,
  })

  React.useEffect(() => {
    if (dirty) {
      // sumbit on change
      handleSubmit()
    }
  }, [values])

  const options = React.useMemo(
    () =>
      sites
        .map((s) => ({ label: i18n.t(`screens.site.sites.${s.codeLieu}`), value: s.id }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [sites]
  )

  const opts = options.filter((o) => values.sites.includes(o.value))

  return (
    <MainContainer>
      {options.length > 0 ? (
        <MultiChoice
          data={options}
          onItemSelected={(next) =>
            setFieldValue(
              'sites',
              next.map((o) => o.value)
            )
          }
          value={opts}
          inline={false}
        />
      ) : (
        <MissingInfo>{i18n.t('screens.admin.users.form.site.noSite')}</MissingInfo>
      )}
    </MainContainer>
  )
}

export default Site

const MainContainer = styled(View)`
  margin: 0 ${(props) => (props.theme.breakpoint === 'phone' ? 24 : 48)}px;
  margin-top: 25px;
  flex: 1;
`

const MissingInfo = styled(Text)`
  ${(props) => props.theme.fonts.Footnote};
  font-size: 14px;
  color: ${(props) => props.theme.colors.secondaryText};
  ${(props) =>
    props.theme.breakpoint === 'phone'
      ? ` padding: 23px 16px;
          background-color: ${props.theme.colors.background};
          text-align: center;
          font-size: 12px;`
      : `padding: 16px 0px;`}
`
